import EverestDealers from "./EverestDealers";
import LastUpdateSummary from "./LastUpdateSummary";
import ExternalOrders from "./ExternalOrders";

import MenuIcon from '@mui/icons-material/Menu';
import { Fab } from "@mui/material";
import { makeStyles } from "@mui/styles";
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import React, { useEffect } from "react";


const useStyles = makeStyles((theme: any) => ({
    // myMenu: { backgroundColor: "green", color: "white !important", paddingBottom: "100px !important" }
}));

export default function EverestMain({ search, DefaultSearch }: { search: string, DefaultSearch: (value: string) => void; }) {
    const [anchorElMenu, setAnchorElMenu] = React.useState(null);
    const classes = useStyles();
    const [menuId, setMenuId] = React.useState(GetDefaultMenuId());

    function GetDefaultMenuId() {
        let val = localStorage.getItem("LastMenuId");
        if (val != null) return val;
        return 1;
    }

    useEffect(() => {
        localStorage.setItem("LastMenuId", menuId.toString());
        if(menuId!=3){
            DefaultSearch("");
        }
    }, [menuId]);

    function opMenuOpenClick(e: any) {
        setAnchorElMenu(e.currentTarget);

    }
    return <div style={{ marginLeft: 20 }}>
        <div style={{ position: "fixed", left: "15px", bottom: "15px" }}>
            <Fab color="primary" aria-label="add" onClick={(event) => { opMenuOpenClick(event) }} >
                <MenuIcon></MenuIcon>
            </Fab>
        </div>
        {menuId == 1 && <EverestDealers search={search} />}
        {menuId == 2 && <LastUpdateSummary />}
        {menuId == 3 && <ExternalOrders search={search} DefaultSearch={DefaultSearch}/>}
        <Menu
            style={{ marginBottom: "100px !important" }}
            id="basic-menu"
            anchorEl={anchorElMenu}
            open={anchorElMenu != null}
            onClose={(event) => { setAnchorElMenu(null) }}
            // classes={{list:classes.myMenu}}
            // anchorOrigin={{
            //     vertical: 'top',
            //     horizontal: 'left',
            //   }}
            //   transformOrigin={{
            //     vertical: 'top',
            //     horizontal: 'left',
            //   }}            
            MenuListProps={{
                'aria-labelledby': 'basic-button',
            }}
        >
            <MenuItem onClick={(e: any) => { setMenuId(1); setAnchorElMenu(null) }} >Dealers</MenuItem>
            <MenuItem onClick={(e: any) => { setMenuId(2); setAnchorElMenu(null) }} >Update Summary</MenuItem>
            <MenuItem onClick={(e: any) => { setMenuId(3); setAnchorElMenu(null) }} >External Orders</MenuItem>


        </Menu>

    </div>;
}


